import React, {ChangeEvent, useEffect, useState} from 'react';
import b_ from 'b_';
import I18N from 'assets/i18n/brandlift-project';

import {SelectWithBodyPopup} from 'client/common/components/lego';

import {useAudienceSegments} from 'client/common/hooks/audience';
import {useIsSuperuser} from 'client/common/hooks/user';

import {AudienceSegmentsOptions} from 'client/common/utils/audience';
import {setError, unsetError, ValidationErrorType} from 'client/common/utils/errors';

import {SegmentsProps} from './types';

const i18n = I18N.common.audienceSettings;
const b = b_.with('audience-settings');

export default function Segments(props: SegmentsProps) {
    const {disabled, onChange, selected} = props;

    const isSuperuser = useIsSuperuser();
    const segments = useAudienceSegments();
    const selectOptions = AudienceSegmentsOptions.getSegmentOptions(segments?.data ?? [], selected);

    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        onChange((event.target.value as unknown) as string[]);
    };

    const selectedSegmentNames = selected.map(
        segmentId => selectOptions.find(segment => segment.value === segmentId)?.checkedText
    );

    const [errorMsg, setErrorMsg] = useState<string>();

    useEffect(() => {
        if (isSuperuser) {
            return;
        }

        if (
            segments.status === 'success' &&
            selected.length &&
            selected.every(selectedSegment =>
                segments.data.map(segment => segment.id).includes(Number(selectedSegment))
            )
        ) {
            setErrorMsg(undefined);
            unsetError('segments');

            return;
        }

        if (selected.length === 0) {
            setErrorMsg(i18n.audienceTargeting.segmentNotProvided);
            setError('segments', ValidationErrorType.InvalidAudience);

            return;
        }

        setErrorMsg(i18n.audienceTargeting.segmentUnavailable);
        setError('segments', ValidationErrorType.InvalidAudience);
    }, [selected, segments, isSuperuser]);

    // Очищаем ошибку если пользователь выбрал "Без таргетингов"
    useEffect(() => {
        return () => {
            setErrorMsg('');
            unsetError('segments');
        };
    }, []);

    return (
        <div title={selectedSegmentNames.join(', ')}>
            <SelectWithBodyPopup
                checkable={false}
                className={b('segments-select')}
                disabled={disabled}
                onChange={handleChange}
                options={selectOptions}
                placeholder={i18n.segments.placeholder}
                size='m'
                value={selected}
                width='max'
                view='dl-clear'
                multiple
            />
            {errorMsg && (
                <p className={`${b('error')} ${errorMsg ? 'error-label' : ''}`}>{errorMsg}</p>
            )}
            {!disabled && <span className={b('segments-notion')}>{i18n.segments.notion}</span>}
        </div>
    );
}
